/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryOfficeTypesResponse } from '../../models/registry-office-types-response';

export interface OfficeControllerGetTypes$Params {
}

export function officeControllerGetTypes(http: HttpClient, rootUrl: string, params?: OfficeControllerGetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeTypesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerGetTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeTypesResponse;
      }>;
    })
  );
}

officeControllerGetTypes.PATH = '/registry/office/types';
